import axios from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {LabelModel, NotificationModel} from './_models'
import {BusinessModel} from '../../auth'

const LABEL_URL = process.env.REACT_APP_API_URL + '/label'
const NOTIFICATION_URL = process.env.REACT_APP_API_URL + '/notification'
const SETTINGS_URL = process.env.REACT_APP_API_URL + '/settings'

const getSettings = (query: string): Promise<BusinessModel> => {
  return axios.get(`${SETTINGS_URL}?${query}`)
}

const updateSettings = (settings: Partial<BusinessModel>): Promise<BusinessModel | undefined> => {
  return axios.patch(`${SETTINGS_URL}`, settings)
}

const getLabels = (query: string): Promise<LabelModel> => {
  return axios.get(`${LABEL_URL}?${query}`)
}

const getLabelById = (id: ID): Promise<LabelModel | undefined> => {
  return axios.get(`${LABEL_URL}/${id}`)
}

const updateLabel = (label: LabelModel): Promise<LabelModel | undefined> => {
  return axios.patch(`${LABEL_URL}`, label)
}

const getNotifications = (query: string): Promise<NotificationModel> => {
  return axios.get(`${NOTIFICATION_URL}?${query}`)
}

const getNotificationById = (id: ID): Promise<NotificationModel | undefined> => {
  return axios.get(`${NOTIFICATION_URL}/${id}`)
}

const updateNotification = (
  notification: NotificationModel
): Promise<NotificationModel | undefined> => {
  return axios.patch(`${NOTIFICATION_URL}`, notification)
}

export {
  getLabels,
  getLabelById,
  updateLabel,
  getNotifications,
  getNotificationById,
  updateNotification,
  getSettings,
  updateSettings,
}
